import React, { Fragment } from "react";

import R from "ramda";

import { Markup, Box } from "src/components";
import { DynamicForm } from "src/components/Form";
import { compose, withState, withHandlers } from "recompose";

const fields = options => ({ t }) => [
  {
    key: "name",
    label: "Your name",
    required: true,
  },
  {
    key: "isMember",
    label: "Are you a Financial Center Member?",
    type: "optionButtons",
    inputProps: {
      options: [
        {
          value: "Yes",
          label: t("forms.feedback.yes"),
        },
        {
          value: "No",
          label: t("forms.feedback.no"),
        },
      ],
    },
  },
  ({ values }) =>
    R.propEq("isMember", "Yes", values) && {
      key: "accountNumber",
      label: "Your account number",
    },
];

const ChatEntryForm = ({ onSubmit }) => (
  <DynamicForm
    formKey="liveChat"
    fields={fields()}
    needsCaptcha={false}
    onSubmit={onSubmit}
  />
);

const enhance = compose(
  withState("chatterInfo", "setChatterInfo"),
  withHandlers({
    onSubmit: ({ setChatterInfo }) => values => setChatterInfo(values),
  })
);

// https://mobile.fcfcu.com/chat/Start.html?chatUsername=Testing%20for%20new%20website&interactionType=Chat&target=WebChat&targetType=Workgroup&acn=12341234&condition=Yes

// Easiest to add as html to get responsiveness from gatsby-remark-responsive-iframe
const getIframe = (chatUrl, { name, isMember, accountNumber }) =>
  `
  <iframe 
    width="800"
    height="600"
    src="${chatUrl}?chatUsername=${encodeURIComponent(
    name
  )}&interactionType=Chat&target=WebChat&targetType=Workgroup&acn=${encodeURIComponent(
    accountNumber
  )}&condition=${encodeURIComponent(isMember)}"
    title="FCFCU Live Chat">Your browser is unable to display frames. Please visit <a href="https://mobile.fcfcu.com/chat/chatform.html">our stand-alone live chat</a>.
  </iframe>
`;

const Chat = enhance(
  ({ header, options, chatterInfo, setChatterInfo, onSubmit }) => (
    <Box>
      {chatterInfo ? (
        <Markup html={getIframe(options.chatUrl, chatterInfo)} />
      ) : (
        <Fragment>
          <Markup html={R.path(["childMarkdownRemark", "html"], header)} />{" "}
          <ChatEntryForm onSubmit={onSubmit} />
        </Fragment>
      )}
    </Box>
  )
);

export default Chat;



// WEBPACK FOOTER //
// ./src/chat/Chat.js